module.exports = __webpack_public_path__ + "static/media/pic7.8e2a22ca.jpg";